import { Route, Routes } from 'react-router-dom';

import { CalendarLayout } from '@/features/calendar/layouts/CalendarLayout';
import { Content } from '@/features/calendar/layouts/content/content';

export const CalendarRoutes = () => {
  return (
    <Routes>
      <Route element={<CalendarLayout />}>
        <Route path="" element={<Content />} />
      </Route>
    </Routes>
  );
};
